import { gql } from '@apollo/client'

export const Query = gql`
  query Accommodations($companyId: ID!, $filters: AccommodationFilters, $after: String, $before: String, $first: Int, $last: Int) {
    accommodations(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        address
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
